import { render, staticRenderFns } from "./BookingWidgetEmbed.vue?vue&type=template&id=0da0ebf2&scoped=true"
import script from "./BookingWidgetEmbed.vue?vue&type=script&lang=js"
export * from "./BookingWidgetEmbed.vue?vue&type=script&lang=js"
import style0 from "./BookingWidgetEmbed.vue?vue&type=style&index=0&id=0da0ebf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0ebf2",
  null
  
)

export default component.exports